import { message, Modal, Upload } from 'antd';
import { observer } from 'mobx-react-lite';
import { useMainContext } from '../../../hooks/useMainContext';
import { IoCloudUploadOutline } from 'react-icons/io5';
import SelectPage from '../SelectPage/SelectPage';
import { useState } from 'react';

const PdfUploadModel = observer(() => {
    const { uiManager, viewManager, closetManager, matrixManager } =
        useMainContext();
    const [isPageSelection, setIsPageSelection] = useState(false);
    const handleUpload = (file) => {
        const isPdf = file.type === 'application/pdf';
        const isLt300MB = file.size / 1024 / 1024 < 300;
        if (!isPdf) {
            message.error('You can only upload PDF files!');
            return Upload.LIST_IGNORE;
        }

        if (!isLt300MB) {
            message.error('File must be smaller than 300MB!');
            return Upload.LIST_IGNORE;
        }
        const form_data = viewManager.formData;
        const updatedFormData = {
            ...form_data,
            pdfFile: { file: file, preview: URL.createObjectURL(file) },
        };
        viewManager.setFormData(updatedFormData);
        viewManager.setPdfFile(file);
        closetManager.setPdfBuffer(file);
        matrixManager.setPdfBuffer(file);
        setIsPageSelection(true);
        return false;
    };

    return (
        <Modal
            footer={null}
            centered
            width={'95vw'}
            height={'90vh'}
            open={uiManager.isPdfUploadModel}
            styles={{
                content: {
                    padding: '32px',
                    borderRadius: '32px',
                    height: '90vh',
                },
            }}
            onCancel={() => {
                if (
                    uiManager.hasPageSelectionChanged &&
                    !viewManager.hasUserFinalized
                ) {
                    const pages = [...uiManager.prevSelectedPages];
                    viewManager.setSelectedPages(pages);
                }
                setIsPageSelection(false);
                uiManager.setIsPdfUploadModel(false);
            }}>
            {viewManager.pdfFile || closetManager.pdfBuffer ? (
                <>
                    <h1 className="font-favorit text-[32px] font-[700] leading-[40px]">
                        Select the pages you want to map
                    </h1>
                    <SelectPage />
                </>
            ) : (
                <>
                    <h1 className="font-favorit text-[32px] font-[700] leading-[40px]">
                        Upload PDF blueprints
                    </h1>
                    <Upload.Dragger
                        name="pdfFile"
                        className="pdf-uploader"
                        multiple={false}
                        beforeUpload={handleUpload}
                        accept=".pdf">
                        <div className="flex justify-center items-center flex-col">
                            <IoCloudUploadOutline className="w-[64px] h-[64px] text-[#F27662]" />
                            <h1 className="font-favorit text-[20px] font-[700] leading-[28px] mt-[20px]">
                                Click or drag file to this area to upload your
                                File
                            </h1>
                            <p className="font-favorit text-[14px] font-[400] leading-[20px] text-[#6C757D] mt-[4px]">
                                Support PDF. Maximum file size 300MB.
                            </p>
                        </div>
                    </Upload.Dragger>
                </>
            )}
        </Modal>
    );
});

export default PdfUploadModel;
